import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  usePDF,
  PDFDownloadLink,
  Image,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: "1px 2px",
  },
  header: {
    fontSize: "12",
    display: "flex",
    flexDirection: "row",
    // margin: "0px 50px 10px 50px",
  },
  words: {
    margin: "5px",
  },
  word1: {
    margin: "5px",
    width: "70%",
  },
  word2: {
    margin: "5px",
    width: "10%",
    textAlign: "right",
  },
  word3: {
    margin: "5px",
    width: "20%",
  },
  section: {
    borderBottom: "1pt dashed black",
    margin: "0px 20px",
    paddingBottom: "5px",
    display: "flex",
    flexDirection: "column",
  },
  section2: {
    fontSize: "14",
    // margin: "0px 52px",
    display: "flex",
    flexDirection: "row",
  },
  item1: {
    marginLeft: "25px",
    fontSize: "12",
    fontWeight: "200",
    width: "140px",
  },
  item2: {
    marginLeft: "25px",
    fontSize: "12",
    width: "30px",
    fontWeight: "200",
    textAlign: "right",
  },
  item3: {
    marginLeft: "5px",
    fontSize: "12",
    width: "90px",
    fontWeight: "200",
  },
});

export default function Labels({
  productName = "Packaged Mini Butter Cheese Cupcakes",
  label = "tset",
  quantity = 2,
}) {
  return (
    <Document>
      {Array.from({ length: quantity }).map((i) => {
        return (
          <Page key={i} size={[180, 72]} style={styles.page}>
            <View
              style={{
                fontSize: "4px",
              }}
            >
              <Text
                style={{
                  fontSize: "7px",
                }}
              >
                {productName}
              </Text>
              <Text
                style={{
                  fontSize: "5px",
                }}
              >
                {label}
              </Text>
            </View>
          </Page>
        );
      })}
    </Document>
  );
}
